import * as Icon from 'react-feather';

export const SIDEBAR_OPTIONS = {
  ALUMNOS: 1,
  SERVICIO_INTERCAMBIO: 2,
  ACTAS: 3,
  BOLETINES: 4,
  MATRICULAS: 5,
  LOGS: 6,
  CALCULO_NOTAS: 7,
  SUPLANTACION_IDENTIDAD: 8,
  ENVIO_EMAILS: 9,
  IMPORTAR_NOTAS_ADDITIO: 10,
  GRUPOS: 11,
  AJUSTES: 12,
  RECIBOS: 13,
  FACTURAS: 14,
  PROFESORES: 15,
  FACTURAR_RECIBOS: 16,
  CLIENTES: 17,
  PRESUPUESTOS: 18,
  DESCUENTOS: 19,
  TICKETS: 20,
  NOTAS_ANTIGUO_CAMPUS: 21,
  PRECIOS: 22,
};

const SidebarData = [
  {
    title: 'Alumnos',
    href: '/alumnos',
    id: 1,
    suffix: '',
    suffixColor: 'bg-info text-dark-white',
    icon: <Icon.User />,
    collapisble: true,
  },
  {
    title: 'SII',
    href: '/servicio-de-intercambio',
    id: 2,
    suffix: '',
    suffixColor: 'bg-info text-dark-white',
    icon: <Icon.Upload />,
    collapisble: true,
  },
  {
    title: 'Profesores',
    href: '/profesores',
    id: SIDEBAR_OPTIONS.PROFESORES,
    suffix: '',
    suffixColor: 'bg-info text-dark-white',
    icon: <Icon.UserPlus />,
    collapisble: true,
  },
  {
    title: 'Clientes',
    href: '/clientes',
    id: SIDEBAR_OPTIONS.CLIENTES,
    suffix: '',
    suffixColor: 'bg-info text-dark-white',
    icon: <Icon.Star />,
    collapisble: true,
  },
  {
    title: 'Actas',
    href: '/actas',
    id: 3,
    suffix: '',
    suffixColor: 'bg-info text-dark-white',
    icon: <Icon.Archive />,
    collapisble: true,
  },
  {
    title: 'Boletines',
    href: '/boletines',
    id: 4,
    suffix: '',
    suffixColor: 'bg-info text-dark-white',
    icon: <Icon.FileText />,
    collapisble: true,
  },
  {
    title: 'Matrículas',
    href: '/solicitudes-matricula',
    id: 5,
    suffix: '',
    suffixColor: 'bg-info text-dark-white',
    icon: <Icon.Briefcase />,
    collapisble: true,
  },
  {
    title: 'Cálculo de notas',
    href: '/calculo-notas',
    id: 7,
    suffix: '',
    suffixColor: 'bg-info text-dark-white',
    icon: <Icon.Edit3 />,
    collapisble: true,
  },
  {
    title: 'Logs',
    href: '/logs',
    id: 6,
    suffix: '',
    suffixColor: 'bg-info text-dark-white',
    icon: <Icon.Activity />,
    collapisble: true,
  },
  {
    title: 'Envío de mails',
    href: '/envio-mails',
    id: SIDEBAR_OPTIONS.ENVIO_EMAILS,
    suffix: '',
    suffixColor: 'bg-info text-dark-white',
    icon: <Icon.Mail />,
    collapisble: true,
  },
  {
    title: 'Simular usuario',
    href: '/suplantacion-identidad',
    id: SIDEBAR_OPTIONS.SUPLANTACION_IDENTIDAD,
    suffix: '',
    suffixColor: 'bg-info text-dark-white',
    icon: <Icon.Users />,
    collapisble: true,
  },
  {
    title: 'Importar notas Additio',
    href: '/importar-notas',
    id: SIDEBAR_OPTIONS.IMPORTAR_NOTAS_ADDITIO,
    suffix: '',
    suffixColor: 'bg-info text-dark-white',
    icon: <Icon.Layers />,
    collapisble: true,
  },
  {
    title: 'Notas antiguo campus',
    href: '/notas-antiguo-campus',
    id: SIDEBAR_OPTIONS.NOTAS_ANTIGUO_CAMPUS,
    suffix: '',
    suffixColor: 'bg-info text-dark-white',
    icon: <Icon.BookOpen />,
    collapisble: true,
  },
  {
    title: 'Grupos',
    href: '/grupos',
    id: SIDEBAR_OPTIONS.GRUPOS,
    suffix: '',
    suffixColor: 'bg-info text-dark-white',
    icon: <Icon.Grid />,
    collapisble: true,
  },
  {
    title: 'Recibos',
    href: '/recibos',
    id: SIDEBAR_OPTIONS.RECIBOS,
    suffix: '',
    suffixColor: 'bg-info text-dark-white',
    icon: <Icon.DollarSign />,
    collapisble: true,
  },
  {
    title: 'Facturar recibos',
    href: '/facturar-recibos',
    id: SIDEBAR_OPTIONS.FACTURAR_RECIBOS,
    suffix: '',
    suffixColor: 'bg-info text-dark-white',
    icon: <Icon.FilePlus />,
    collapisble: true,
  },
  {
    title: 'Facturas',
    href: '/facturas',
    id: SIDEBAR_OPTIONS.FACTURAS,
    suffix: '',
    suffixColor: 'bg-info text-dark-white',
    icon: <Icon.CreditCard />,
    collapisble: true,
  },

  {
    title: 'Presupuestos',
    href: '/presupuestos',
    id: SIDEBAR_OPTIONS.PRESUPUESTOS,
    suffix: '',
    suffixColor: 'bg-info text-dark-white',
    icon: <Icon.Clipboard />,
    collapisble: true,
  },
  {
    title: 'Descuentos',
    href: '/descuentos',
    id: SIDEBAR_OPTIONS.DESCUENTOS,
    suffix: '',
    suffixColor: 'bg-info text-dark-white',
    icon: <Icon.Percent />,
    collapisble: true,
  },
  {
    title: 'Precios',
    href: '/precios',
    id: SIDEBAR_OPTIONS.PRECIOS,
    suffix: '',
    suffixColor: 'bg-info text-dark-white',
    icon: <Icon.Tag />,
    collapisble: true,
  },
  {
    title: 'Soporte',
    href: '/tickets',
    id: SIDEBAR_OPTIONS.TICKETS,
    suffix: '',
    suffixColor: 'bg-info text-dark-white',
    icon: <Icon.LifeBuoy />,
    collapisble: true,
  },
  {
    title: 'Ajustes',
    href: '/ajustes',
    id: SIDEBAR_OPTIONS.AJUSTES,
    suffix: '',
    suffixColor: 'bg-info text-dark-white',
    icon: <Icon.Tool />,
    collapisble: true,
  },
];

export default SidebarData;
